/* eslint-disable @typescript-eslint/no-explicit-any */
import { bootstrapApplication } from "@angular/platform-browser";
import { App } from "./app/app";
import { appConfig } from "./app/app.config";

// Globally override JSON.stringify to gracefully handle circular structures.
// This prevents Uncaught TypeErrors when third-party libraries or internal
// console log interceptors attempt to serialize complex cyclic objects.
const originalStringify = JSON.stringify;
JSON.stringify = function (
  value: any,
  replacer?: any,
  space?: string | number,
) {
  try {
    return originalStringify(value, replacer, space);
  } catch (err: any) {
    if (
      err instanceof TypeError &&
      err.message.toLowerCase().includes("circular")
    ) {
      const cache = new Set();
      return originalStringify(
        value,
        (k, v) => {
          const val = typeof replacer === "function" ? replacer(k, v) : v;
          if (typeof val === "object" && val !== null) {
            if (cache.has(val)) return "[Circular]";
            cache.add(val);
          }
          return val;
        },
        space,
      );
    }
    throw err;
  }
};
/* eslint-enable @typescript-eslint/no-explicit-any */

console.log("Kicgle app is bootstrapping...");
bootstrapApplication(App, appConfig).catch((err) => {
  console.error("CRITICAL: Bootstrap failed!", err);
});

// PWA Service Worker Registration (Disabled for stability)
